import React from 'react'
import {FieldErrors} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'

interface ErrorSummaryProps {
    errors: FieldErrors<any>
    isSubmitted: boolean
}

const ErrorSummaryWrapper = styled.div`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
`

export const ErrorSummary: React.FC<ErrorSummaryProps> = ({
    errors,
    isSubmitted,
}) => {
    const {t} = useTranslation()

    const hasErrors = Object.keys(errors).length > 0

    if (!isSubmitted || !hasErrors) {
        return null
    }

    const errorCount = Object.keys(errors).length
    const summaryMessage =
        errorCount === 1
            ? t('form.errorSummary.oneError')
            : t('form.errorSummary.multipleErrors', {count: errorCount})

    return (
        <ErrorSummaryWrapper
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            aria-relevant="additions text"
        >
            {summaryMessage}
        </ErrorSummaryWrapper>
    )
}
